import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { api } from 'path-shared/configuration/urls';
import { config } from 'path-shared/configuration/config';
import { HttpParams } from '@angular/common/http';
import { ObservacionsPdaFilterService } from './observacions-pda-filter.service.ts.service';
import { ObservacionsPdaFilter } from '../models/observacions-pda-filter';
import { ObservacioPda } from '../models/observacions-pda.model';

const defaultSortParam = 'codi';
const defaultSortDirection = 'desc';

@Injectable()
export class ObservacionsPdaService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}

  setObservacioPda(p: ObservacioPda): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetObservacioPda'], p);
    }
  }

  removeObservacioPda(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteObservacioPda'].replace('{secure_id}', secure_id), null);
    }
  }

  getObservacioPda(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetObservacioPda'].replace('{secure_id}', secure_id), null);
    }
  }


  generateExcel(filter: ObservacionsPdaFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new ObservacionsPdaFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

    if (this.authGuard.canActivate()) {
      return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlObservacionsPdaExcel'],  params );
    }
  }
}
